<template>
<div>
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" class="back-link w-inline-block" @click.prevent="goBack()">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Video Meeting Steps</div>
                        </div>
                        
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>
    </section>
    <section class="explainer-section">
        <div class="exp_wrap">
            <div class="exp_div">
                <div class="exp_headers-div">
                    <div class="text-block-1346">Our Process: Fast, Simple and Built for You</div>
                    <p class="paragraph-171">Get started today — complete your online visit in minutes and <strong>receive your medication at your door in 48 hours or less.</strong></p>
                </div>
                <div class="stepexp-div">
                    <div class="step_text-div">
                        <div class="text-block-1324">Step 1</div>
                        <div class="text-block-1325">Confirm Your Address</div>
                        <p class="paragraph-169">We need to double check your address is correct before we ship your medication.</p>
                    </div>
                    <div class="step-exp-imgdiv"><img src="@/assets/images/Explainer-Screens_info.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/Explainer-Screens_info-p-500.webp 500w, @/assets/images/Explainer-Screens_info-p-800.webp 800w, @/assets/images/Explainer-Screens_info.webp 1080w" alt=""></div>
                </div>
                <div class="stepexp-div">
                    <div class="step_text-div">
                        <div class="text-block-1324">Step 2</div>
                        <div class="text-block-1325">Turn on Camera <span class="text-span-288">(or not)</span></div>
                        <p class="paragraph-169">Hit connect to speak with your doctor directly. It usually only takes less than 5 minutes for them to get on during working hours.</p>
                    </div>
                    <div class="step-exp-imgdiv"><img src="@/assets/images/Explainer-Screens_cam.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/Explainer-Screens_cam.webp 500w, @/assets/images/Explainer-Screens_cam.webp 800w, @/assets/images/Explainer-Screens_cam.webp 1080w" alt="" class="image-572"></div>
                </div>
                <div class="stepexp-div">
                    <div class="step_text-div">
                        <div class="text-block-1324">Step 3</div>
                        <div class="text-block-1325">Meet your doctor</div>
                        <p class="paragraph-169">The meeting usually takes less than 5 minutes and the doctor will send your prescription to one of our partner pharmacies.</p>
                    </div>
                    <div class="step-exp-imgdiv"><img src="@/assets/images/Explainer-Screens_drcall.webp" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" srcset="@/assets/images/Explainer-Screens_drcall.webp 500w, @/assets/images/Explainer-Screens_drcall.webp 800w, @/assets/images/Explainer-Screens_drcall.webp 1080w" alt=""></div>
                </div>
                <a href="#" @click.prevent="pushToRoute()" class="form-button w-button balugabtn deskbutton">Click Here to Start -&gt;</a>
            </div>
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'GLPScreening',
    components: {},
    props: {},
    data() {
        return {}
    },
    methods: {
        pushToRoute() {
            const meetingId = this.$route.params.id;
            window.location.href = `https://app.qualiphy.me/meeting/${meetingId}`;
        }
    }
}
</script>

<style scoped>
.deskbutton{
    max-width: 468px;
}
.text-block-1346 {
    color: #000;
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 40px;
    font-weight: 900;
    line-height: 45px;
}

.exp_wrap {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    padding: 30px 10% 100px;
    display: flex;
}

.exp_div {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    max-width: 1280px;
    display: flex;
}

.exp_headers-div {
    text-align: center;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 50px;
    display: flex;
}

.paragraph-171 {
    text-align: center;
    width: 70%;
    margin-bottom: 0;
}

.button-139 {
    text-align: center;
    border-radius: 9px;
    width: 70%;
    margin-top: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    font-family: Inter, sans-serif;
    font-size: 23px;
    font-weight: 600;
    line-height: 24px;
}

.stepexp-div {
    border: 1px #000;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 30px;
    display: flex;
}

.image-573 {
    width: 200px;
    max-width: none;
    height: auto;
}

.step_text-div {
    border: 1px none;
    border-radius: 15px;
    width: 60%;
    padding: 30px 0 30px 30px;
}

.text-block-1324 {
    color: #000;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 900;
    line-height: 24px;
    font-family: Inter, sans-serif;
}

.text-block-1325 {
    color: #000;
    font-size: 28px;
    font-weight: 900;
    line-height: 30px;
    font-family: Inter, sans-serif;
    padding-bottom: 20px;
}

.step-exp-imgdiv {
    width: 40%;
    padding-right: 30px;
}

.paragraph-169 {
    width: 90%;
}

.text-span-288 {
    font-size: 22px;
    font-weight: 500;
}

.image-572 {
    border-radius: 12px;
}

/* Media query for mobile responsiveness */
@media screen and (max-width: 479px) {
    .exp_wrap {
        padding-left: 3%;
        padding-right: 3%;
    }

    .text-block-1346 {
        font-size: 33px;
        line-height: 36px;
    }

    .paragraph-171,
    .button-139 {
        width: 100% !important;
    }

    .stepexp-div {
        flex-flow: column;
        padding: 0 0 50px;
    }

    .step_text-div {
        width: 100%;
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
    }

    .step-exp-imgdiv {
        width: 100%;
        padding-right: 0;
    }
}
</style>
